var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1E3D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.795 1.21a2.42 2.42 0 0 0-3.438.023l-9.644 9.64L.5 15.5l4.628-1.213 9.643-9.64a2.42 2.42 0 0 0 .024-3.438M11.08 1.509l3.415 3.413M9.688 2.9l3.415 3.414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1E3D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1.713 10.873 2.394 1.022 1.024 2.389M11.395 4.607l-7.288 7.287"
  })));
};
export default SvgPencil;